/*
 * @Author: Teemo Ding
 * @Date: 2021-06-15 14:28:52
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-15 14:46:00
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/ListPage/Preview/index.tsx
 */
import React from 'react';

import { ImagePlaceholder } from 'unifyxp-ecomm-components';

import styles from './style.module.less';

function Preview() {
  return (
    <div className={styles.container}>
      <ImagePlaceholder width={'100%'} height={'100vh'} />
    </div>
  );
}

export default Preview;
